import { Box } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import { useListarMarcasVeiculo } from "core/features/veiculo/hooks/useListarMarcasVeiculo";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

export interface SelectMarcaVeiculoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}

function SelectMarcaVeiculo({
  value,
  onChange,
  isInvalid,
  errorMessage,
  ...rest
}: SelectMarcaVeiculoProps) {
  const [search, setSearch] = useState<string | undefined>();
  const { isLoading, isFetching, data } = useListarMarcasVeiculo();

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={isLoading || isFetching}
      size="large"
      placeholder="Selecione a marca"
      style={{ width: "100%", flexGrow: 1, flex: 1 }}
      value={value || undefined}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      notFoundContent={<Box>Nenhuma marca encontrada</Box>}
    />
  );
}

export default SelectMarcaVeiculo;
